// Module
var code = "<point-form :item=\"viewPoint\" :color=\"color\" :form=\"'edit'\" ref=\"form\"> </point-form> ";
// Exports
module.exports = code;